import React from 'react';
import {
  Box,
  Button,
  Divider,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import { EmptyState, StatusChip } from '../../../components/admin';
import { resolveStatusToken } from '../../../constants/statusTokens';

const RecentEvents = ({ events, navigate }) => (
  <List
    sx={{
      flexGrow: 1,
      maxHeight: 320,
      overflowY: 'auto',
      pr: 1,
      '&::-webkit-scrollbar': { width: 6 },
      '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(15, 23, 42, 0.2)', borderRadius: 3 },
    }}
  >
    {events.length === 0 && (
      <ListItem sx={{ px: 0 }}>
        <EmptyState
          title="No incidents logged yet"
          description="Live alerts will appear here as soon as falls are detected."
          minHeight={120}
        />
      </ListItem>
    )}
    {events.map((event, index) => {
      const statusKey = event.status?.toUpperCase?.() || '';
      const token = resolveStatusToken(statusKey, 'fallEvents');
      const chipColor = token?.color || 'default';
      return (
        <Box key={event.id || index}>
          <ListItem alignItems="flex-start" sx={{ alignItems: 'stretch' }}>
            <ListItemAvatar>
              <Avatar
                variant="rounded"
                sx={{ bgcolor: chipColor === 'default' ? 'primary.main' : `${chipColor}.main` }}
              >
                <WarningAmberIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={(
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography fontWeight={600}>
                    {event.camera_name || event.camera?.name || 'Unknown camera'}
                  </Typography>
                  {statusKey && (
                    <StatusChip status={statusKey} category="fallEvents" />
                  )}
                </Stack>
              )}
              secondary={(
                <Stack spacing={1} sx={{ mt: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    {new Date(event.timestamp || event.detected_at || Date.now()).toLocaleString()}
                    {event.notes ? ` - ${event.notes}` : ''}
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    <Button size="small" variant="outlined" onClick={() => navigate('/fall-events')}>
                      Open details
                    </Button>
                    {event.video_snippet && (
                      <Button
                        size="small"
                        variant="text"
                        onClick={() => window.open(event.video_snippet, '_blank', 'noopener')}
                      >
                        View clip
                      </Button>
                    )}
                  </Stack>
                </Stack>
              )}
            />
          </ListItem>
          {index < events.length - 1 && <Divider component="li" />}
        </Box>
      );
    })}
  </List>
);

export default RecentEvents;
